// eslint-disable-next-line boundaries/element-types
import { AuthedAxiosRequests } from 'features/auth'

export const uploadFileAndMetaData = async (
  file: File,
  metaData: Record<string, string | number | Date | undefined>,
  riskCalculatorURl: string,
  axios: AuthedAxiosRequests
) => {
  const formData = new FormData()
  formData.append('file', file)
  const stringifiedMetaData = JSON.stringify(metaData)
  formData.append('metaData', stringifiedMetaData)

  return axios.post(`${riskCalculatorURl}/hhut/uploadFileAndMetadata`, formData)
}
